// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3q6gm","gfeWrapper":"CalendarEvent_gfeWrapper__27c1B"};